module.exports = __webpack_public_path__ + "img/scratch_lords.40b1d37b.png";